/** 评估项目专利列表 */
<template>
  <div class="patent">
    <TableList
      :table-data="tableData"
      :label-data="tableLabel"
      :loading="loading"
      :page="currentPage"
      :page-total="pageTotal"
      @changePage="changePage"
    >
      <template v-slot:btns>
        <el-button type="primary" plain round @click="$router.back()"> 返回项目列表 </el-button>
      </template>
    </TableList>
  </div>
</template>

<script>
import * as assessApi from "@/api/assessment.js";
import Search from "@/components/Search";
import TableList from "@/components/TableList";
export default {
  name: "Patent",
  components: {
    Search,
    TableList
  },
  data() {
    return {
      tableData: [],
      tableLabel: [
        { label: "专利号", value: "patent_num" },
        { label: "专利名称", value: "patent_name" },
        { label: "专利类型", value: "patent_type" },
        { label: "申请日", value: "apply_at" },
        { label: "授权公告日", value: "impower_at" },
        { label: "剩余年限(年)", value: "zlyear" },
        { label: "状态", value: "patent_state" }
      ],
      currentPage: 1,
      pageTotal: null,
      loading: true
    };
  },
  computed: {
    projectId() {
      return this.$route.query.projectId;
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getPatentList();
  },
  methods: {
    async getPatentList(page = 1) {
      this.loading = true;
      try {
        const { data } = await assessApi.getPatentList({
          page,
          projectId: this.projectId
        });
        this.tableData = data.data.map(v => {
          v["apply_at"] = this.$utils.formatDate(v["apply_at"], "yyyy-MM-dd");
          v["impower_at"] = this.$utils.formatDate(v["impower_at"], "yyyy-MM-dd");
          return v;
        });
        this.currentPage = page;
        this.pageTotal = data.total;
      } catch (error) {}
      this.loading = false;
    },

    // 分页
    async changePage(page) {
      this.getPatentList(page);
    }
  }
};
</script>

<style scoped lang="less"></style>
